import { IFormSchema } from "../interfaces/IFormSchema";
import { EEvaluationStatus, IEvaluations } from "../interfaces/IEvaluation";
import selectn from "selectn";
import { TEvaluationCehckValue } from "../components/form/jsonSchemaWidgets/EvaluationCheck/EvalutaionCheckWidget";
import { TEvaluationCounterValue } from "../components/form/jsonSchemaWidgets/EvaluationCounter/EvaluationCounterWidget";
import { JSONSchema, JSONSchemaDefinition } from "../../sg-schema/RJSF";
import { mapAuditingToEvaluations } from "../../@custom/sg-mapAuditing/components/MapAuditing.utils";

const EVALUATION_WIDGET_LIST = ["evaluationCheck", "evaluationCounter"];

/**
 * Makes best guess wheter property is evaluation check or counter
 */
const isEvaluationField = (uiProps: { [key: string]: any }) => {
    return uiProps["ui:field"] === "evaluation" || EVALUATION_WIDGET_LIST.includes(uiProps["ui:widget"])
};

/**
 * Loops trough each schema property
 * @param properties 
 * @param invoke 
 * @param pathBase 
 */
const forEachSchemaProp = (
    properties: JSONSchema["properties"],
    invoke: (path: string, prop: JSONSchemaDefinition) => void,
    pathBase?: string
) => {
    if (!properties) { return };

    Object.keys(properties).forEach((key) => {
        const prop = properties[key];
        if (prop === true || prop === false) { return };

        if (prop.type === "object") {
            if (prop.additionalProperties) {
                invoke(pathBase ? [pathBase, key].join(".") : key, prop);
            }
            forEachSchemaProp(prop.properties, invoke, key);
            return
        }

        const path = pathBase ? [pathBase, key].join(".") : key;
        invoke(path, prop);
    });
};

/**
 * Sets value by property path
 */
function setToValue(obj: { [key: string]: any }, value: any, path: string) {
    var i;
    //@ts-ignore
    path = path.split('.');
    for (i = 0; i < path.length - 1; i++) {
        obj = (obj || {})[path[i]];

    }

    (obj || {})[path[i]] = value;

}

/**
 * Gathers all unfilled evaluation check and counter fields, and returns list schema property paths
 */
export const fillUnfilledFields = (formData: { [key: string]: any }, unfilledFields: string[]) => {

    const filledValue: TEvaluationCehckValue = { status: EEvaluationStatus.Uknown as any, notes: [] }

    unfilledFields.forEach((path) => {
        setToValue(formData, filledValue, path);
    });

    return formData
};




/**
 * Gathers all unfilled evaluation check and counter fields, and returns list schema property paths
 */
export const getUnfilledFields = (formData: { [key: string]: any }, schemas: IFormSchema) => {
    const { uiSchema, schema } = schemas
    if (!schema?.properties) { return };
    if (schemas.uiSchema["ui:consentEvaluationChecks"] !== true) { return };

    let unfilledFields: string[] = [];

    forEachSchemaProp(schema.properties, (path, prop) => {
        const uiProps = selectn(path, uiSchema) || {};
        if (isEvaluationField(uiProps)) {
            const value: TEvaluationCehckValue & TEvaluationCounterValue | undefined = selectn(path, formData);

            if ((!value || typeof value.status === "undefined") && (!value || (!value.notOkay && !value.okay))) {
                unfilledFields.push(path)
            }
        };
    })

    return unfilledFields
};


/**
 * Gathers all evaluation check and counter fields, and returns mapping of schema property paths and values
 */
export const resolveEvaluationsData = (formData: { [key: string]: any }, schemas: IFormSchema) => {
    const { uiSchema, schema } = schemas
    if (!schema?.properties) { return };

    let data: IEvaluations = {};

    forEachSchemaProp(schema.properties, (path, prop) => {
        const uiProps = selectn(path, uiSchema) || {};

        if (isEvaluationField(uiProps)) {
            const value = selectn(path, formData);
            data[path] = value;

        } else if (uiProps["ui:field"] === "mapAuditing") {
            const mapAuditingValue = selectn(path, formData) || {};
            const mappedChecks = mapAuditingToEvaluations(mapAuditingValue, path);
            data = { ...data, ...mappedChecks };
        }
    })

    return data;
};

